import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, AreaChart, Area,
} from 'recharts';
import { Flame, Hash, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const COLORS = ['#22c55e', '#3b82f6', '#ec4899', '#f59e0b', '#06b6d4', '#8b5cf6', '#ef4444', '#14b8a6', '#a855f7', '#f97316'];

const TOOLTIP_STYLE = {
  backgroundColor: '#1e293b',
  border: '1px solid #334155',
  borderRadius: '8px',
};

export const FrequencyChart = ({ data, lotteryColor }) => (
  <Card className="glass-card" data-testid="top20-chart">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Flame size={20} className="text-pink-400" />Top 20 Numeros Mas Frecuentes
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
            <XAxis type="number" tick={{ fill: '#94a3b8' }} />
            <YAxis dataKey="number" type="category" tick={{ fill: '#94a3b8', fontFamily: 'JetBrains Mono' }} width={40} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={{ color: '#fff' }} />
            <Bar dataKey="count" fill={lotteryColor || '#22c55e'} radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CardContent>
  </Card>
);

export const DecadeDistributionChart = ({ data }) => (
  <Card className="glass-card" data-testid="decade-chart">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Hash size={20} className="text-blue-400" />Distribucion por Decenas
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} cx="50%" cy="50%" labelLine label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={100} dataKey="value">
              {data.map((entry, index) => (
                <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip contentStyle={TOOLTIP_STYLE} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </CardContent>
  </Card>
);

export const TrendChart = ({ data, resultsCount }) => (
  <Card className="glass-card mb-6" data-testid="trend-chart">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <TrendingUp size={20} className="text-green-400" />
        Tendencia de Numeros (Ultimos {Math.min(30, resultsCount)} sorteos)
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
            <XAxis dataKey="date" tick={{ fill: '#94a3b8' }} />
            <YAxis tick={{ fill: '#94a3b8' }} domain={[0, 99]} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={{ color: '#fff' }} />
            <Area type="monotone" dataKey="num1" stroke="#22c55e" fill="#22c55e40" name="1er Numero" />
            <Area type="monotone" dataKey="num2" stroke="#3b82f6" fill="#3b82f640" name="2do Numero" />
            <Area type="monotone" dataKey="num3" stroke="#ec4899" fill="#ec489940" name="3er Numero" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </CardContent>
  </Card>
);
